<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getBidding">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.bidding_number" 
                        type="text" 
                        class="form-control" 
                        placeholder="RFP Number or Tender Number..." 
                        aria-label="RFP Number or Tender Number..." 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Estimated Delivery Date</label>
                    <Datepicker 
                      v-model="search.bidding_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder">RFP Number</th>
                      <th class="text-uppercase text-xxs fw-bolder ps-2">Tender Number</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Estimated Delivery Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Amount</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bidding in bidding_list" :key="bidding.bidding_id">
                      <td>
                          <router-link :to="'/request-for-proposal/' + bidding.bidding_id" class="text-xs text-primary fw-bold mb-0 ps-3">
                            {{ bidding.bidding_name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ bidding.tender_name }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ bidding.estimated_date }}</p>
                      </td>
                      <td>
                        <p class="text-xs text-end mb-0">{{ bidding.amount_total }}</p>
                      </td>
                      <td class="align-middle text-sm">
                        <template v-if="bidding.state_value === 'draft'">
                            <span class="badge badge-sm bg-secondary">{{ bidding.state }}</span>
                        </template>
                        <template v-else-if="bidding.state_value === 'review'">
                            <span class="badge badge-sm bg-info">{{ bidding.state }}</span>
                        </template>
                        <template v-else-if="bidding.state_value === 'accepted'">
                            <span class="badge badge-sm bg-success">{{ bidding.state }}</span>
                        </template>
                        <template v-else-if="bidding.state_value === 'win'">
                            <span class="badge badge-sm bg-primary">{{ bidding.state }}</span>
                        </template>
                        <template v-else>
                            <span class="badge badge-sm bg-danger">{{ bidding.state }}</span>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!bidding_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "bidding",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState
    // ArgonInput
  },
  data() {
    return {
      search: {
          bidding_number: null,
          bidding_date: [],
          delivery_date: [],
      },
      bidding_list: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      record_more: false,
      offset: 0,
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getBidding()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getBidding()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getBidding() {
      this.bidding_list = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const bidding_daterange = this.getDate(this.search.bidding_date)
      let offset = 0
      if (bidding_daterange.length > 0 || this.search.bidding_number) {
        offset = 0
      } else {
        offset = this.offset
      }
      this.axios
        .post(
          endpoint.BIDDING_LIST,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            name: this.search.bidding_number || '',
            date_from: bidding_daterange.length > 0 ? bidding_daterange[0] : '',
            date_to: bidding_daterange.length > 1 ? bidding_daterange[1] : '',
            limit: 10,
            offset: offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
          this.$notify({
              type: 'warn',
              title: 'Expired',
              text: 'Session expired, please sign in again.',
          });
          this.$router.replace('/signin')
          return false
        } else if (response.data.response_code === "0000") {
            this.bidding_list = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message || e,
          });
          this.loading = false
        });
    }
  },
  mounted() {
    this.getBidding();
  }
};
</script>

<style>

</style>